import React, { useState, useEffect } from 'react';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'reactstrap';
import moment from 'moment';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import Loading from '../../../components/Loading/Loading';
import FichaGeradorContainer from './components/FichaGeradorContainer';
import NovoGerador from './NovoGerador';
import AnaliseGeradorLocalidade from './components/AnaliseGeradorLocalidade';
import FichaVistoria from '../../Shared/Vistoria/FichaVistoria';

//Api
import gerador_api from '../../../api/gerador_api';
import setup_api from 'api/setup_api';

// Contexts
import { useAuth } from "../../../context/auth.js";

//Helpers
import { showMessage } from '../../../helpers/message';
import { getSessionCookie } from '../../../helpers/cookies';


export default function FichaGerador({ btnVoltar, id = null, permissao, integracaoCadastros }) {
    //Estado de controle de exibição dos dados da vistoria
    const [vistoria, setVistoria] = useState();

    const { setupVariavel } = useAuth();

    //Dados do usuario logado
    const usuario = getSessionCookie();

    //Estado de controle dos dados do gerador
    const [gerador, setGerador] = useState(null);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(true);

    //Estado de controle de edição do gerador
    const [novo, setNovo] = useState(false);

    //
    const [analiseCadastro, setAnaliseCadastro] = useState(false)

    const [setup, setSetup] = useState()

    //Inicializando os dados do gerador que vão ser mostrados na ficha
    useEffect(() => {
        setLoading(true);
        gerador_api.GetItem(id ? id : 0).then(response => {
            if (response.data.tbPrefeituras_id) {
                response.data.tbPrefeituras_id = response.data.tbPrefeituras_id.toString();
            }
            if (response.data.tbSetores_Id) {
                response.data.tbSetores_Id = response.data.tbSetores_Id.toString();
            }
            if (response.data.tbSegmentos_Id) {
                response.data.tbSegmentos_Id = response.data.tbSegmentos_Id.toString();
            }
            if (response.data.dataValidade) {
                response.data.dataValidade = moment(response.data.dataValidade).format("YYYY-MM-DD")
            }
            
            response.data.localidades = response.data.localidades.map(localidade => {
                if (localidade.localidadePadrao) {
                    localidade.principal = "Sim";
                } else {
                    localidade.principal = "Não";
                }
                localidade.contratos = localidade.contratos.map(contrato => {
                    Object.keys(contrato).map(key => {
                        if (!contrato[key] === null) {
                            contrato[key] = "";
                        }

                    });
                    contrato.quantidadeContratada = contrato.quantidadeContratada ? contrato.quantidadeContratada.toString().replace(".", ",") : "";
                    return contrato;
                });

                return localidade;
            })
            setGerador(response.data);

            loadSetup();
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }, []);

    const loadSetup = () => {
        setup_api.GetVariaveisSetup()
        .then(response => {
            setSetup(response.data)
        })
        .catch(err => showMessage("Erro", "Error na operação.", "error", null));
    }

    //Controlando o loading para ser exibido na tela
    if (loading) {
        return <Loading />
    }

    //Estado de controle de exibição 
    if (vistoria) {
        return <FichaVistoria
            agendamentoId={vistoria}
            btnVoltar={() => setVistoria(null)}
        />
    }

    //Controlando o momento em que a tela de editar vai ser exibida na tela
    if (novo) {
        return <NovoGerador
            btnVoltar={btnVoltar}
            geradorParam={gerador}
            integracaoCadastros={integracaoCadastros}
        />
    }

    //Função de controle de exibição do botão de ação 1
    const BtnAction1 = () => {
        if (usuario?.acesso?.sigla == "GS" && setupVariavel.requerAnaliseGeradorLocalidade) {
            return (<Button onClick={() => {
                setAnaliseCadastro(true)
            }} color="bg-gradient bg-primary text-light"><FontAwesomeIcon icon={faSearch} /> Análise do Cadastro</Button>)

        }
        return null;
    }

    if(analiseCadastro)
    {
        return <AnaliseGeradorLocalidade btnVoltar={btnVoltar} geradorSelecionado={gerador} />
    }
    
    return (
        <MainCard
            btnVoltar={btnVoltar}
            BtnAction1={usuario.acesso.sigla == "GS" ? BtnAction1 : null}
            btnEditar={(permissao == "Editar" && ((!integracaoCadastros && usuario.acesso.sigla == "GS") || usuario.acesso.sigla == "TR") || (usuario.acesso.sigla == "GG" && setup?.quemCadastraGeradores == "Gerador")) ? () => setNovo(true) : null}
        >
            <FichaGeradorContainer
                gerador={gerador}
                modulo={usuario.acesso.modulo}
                setVistoria={setVistoria}
                integracaoCadastros={integracaoCadastros}
            />
        </MainCard>
    )

}